export default __webpack_public_path__ + "static/media/banner-12.519c66fe.png";